import { render, staticRenderFns } from "./LanguageFlag.vue?vue&type=template&id=7e1145da&scoped=true"
import script from "./LanguageFlag.vue?vue&type=script&lang=js"
export * from "./LanguageFlag.vue?vue&type=script&lang=js"
import style0 from "./LanguageFlag.vue?vue&type=style&index=0&id=7e1145da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1145da",
  null
  
)

export default component.exports